import { Icon, IconSource } from '@shopify/polaris'
import {
    ChannelsIcon,
    ChartHistogramGrowthIcon,
    DeliveryFilledIcon,
    DnsSettingsIcon,
    LanguageTranslateIcon,
    ListBulletedIcon,
    PersonExitIcon,
    PinIcon,
    QuestionCircleIcon,
} from '@shopify/polaris-icons'
import { signOut } from 'firebase/auth'
import React, { useCallback, useState } from 'react'
import { useHotkeys } from 'react-hotkeys-hook'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { resetUserData } from '../../core/redux/store/userSlice/userSlice'
import { checkHasAccessModule } from '../../helpers/checkHasAccess'
import { auth } from '../../services/firebase/firebaseConfig'

const Nav = () => {
    useHotkeys('ctrl+shift+1', () => goToPage('/dateRegion'))
    useHotkeys('ctrl+shift+2', () => goToPage('/routes'))
    useHotkeys('ctrl+shift+3', () => goToPage('/mapFleet'))
    useHotkeys('ctrl+shift+4', () => goToPage('/reports'))
    useHotkeys('ctrl+shift+6', () => goToPage('/admin'))
    useHotkeys('ctrl+shift+l', () => setIsActive(true))

    const actions = useSelector((state: any) => state.user.actions)
    const [isActive, setIsActive] = useState(false)
    const [languageMessage, showLanguageMessage] = useState('')
    const { t, i18n } = useTranslation()
    const history = useHistory()

    const onChangeLanguage = useCallback(
        (lang: string) => {
            i18n.changeLanguage(lang)
        },
        [i18n]
    )
    const logout = useCallback(async () => {
        signOut(auth).then((res) => {
            // TBD: I had to refresh the page when user logout.
            // Otherwise history push keeps generating duplicate component tree and causes duplicate onAuthStateChanged event in mainRoutes.tsx
            // There should be a better way to handle 'route' using useNavigate or something else
            window.location.assign('/login')
        })
    }, [resetUserData])

    const goToPage = useCallback(
        (path) => {
            history.push(path)
        },
        [history]
    )

    const MainNavigations = [
        { path: '/dateRegion', label: 'nav.drawer.orders', icon: ListBulletedIcon, tooltip: 'nav.tooltip.orders' },
        { path: '/routes', label: 'nav.drawer.routes', icon: DeliveryFilledIcon, className: 'guide-routing', tooltip: 'nav.tooltip.routes' },
        { path: '/mapFleet', label: 'nav.drawer.mapFleet', icon: ChannelsIcon, className: 'guide-network', tooltip: 'nav.tooltip.mapFleet' },
        { path: '/analytics', label: 'nav.drawer.report', icon: ChartHistogramGrowthIcon, tooltip: 'nav.tooltip.report' },
        { path: '/trackorder', label: 'nav.drawer.trackOrder', icon: PinIcon, tooltip: 'nav.tooltip.trackOrder' },
        { path: '/mainContainer', label: '', icon: null },
        { path: '/mainContainer', label: '', icon: null },
        { path: '/admin', label: 'nav.drawer.admin', icon: DnsSettingsIcon, tooltip: 'nav.tooltip.admin' },
    ]

    const getMainNavigations = useCallback(() => {
        return MainNavigations.filter((item) => checkHasAccessModule(item.path, actions)).map(renderNavItem)
    }, [actions])

    const handleChangeLang = useCallback(
        (lang: string) => {
            onChangeLanguage(lang)
            setIsActive(false)
        },
        [onChangeLanguage]
    )

    const renderNavItem = useCallback((item, index) => {
        return item.icon ? (
            <div
                className={`shyftbase_main_nav_item ${
                    (window.location.href.includes('records') ? '/dateRegion' : window.location.href).includes(
                        item.path
                    )
                        ? 'selected'
                        : ''
                } ${item.className ? item.className : ''}`}
                onClick={() => goToPage(item.path)}
                key={`nav_${item.path}_${index}`}
            >
                        <span className='sb_tooltiptext_nav'>
                                     {t(item.tooltip)}
                                </span>
            
                <Icon source={item.icon} />
                <p>{t(item.label)}</p>
            </div>
        ) : (
            <div className="shyftbase_main_nav_item toggle" key={`nav_${item.path}_${index}`}></div>
        )
    }, [])
    return (
        <>
            <div className={`modal ${isActive ? 'is-active' : ''}`}>
                <div className="modal-background"></div>
                <div
                    className="is-flex is-flex-direction-column justify-content-center "
                    style={{ maxWidth: 400, minWidth: 400 }}
                >
                    <button
                        className="my-1 button is-fullwidth"
                        onClick={() => {
                            handleChangeLang('en'), showLanguageMessage('')
                        }}
                    >
                        English
                    </button>
                    <button className="my-1 button is-fullwidth" onClick={() => showLanguageMessage('fr')}>
                        Français
                    </button>
                    <button className="my-1 button is-fullwidth" onClick={() => showLanguageMessage('de')}>
                        Deutsch
                    </button>
                    <button className="my-1 button is-fullwidth" onClick={() => showLanguageMessage('sp')}>
                        Español
                    </button>
                    {languageMessage === 'fr' && (
                        <div className="my-2 button is-fullwidth is-7 title has-text-center">
                            Le portail est en cours de traduction en français!
                        </div>
                    )}
                    {languageMessage === 'de' && (
                        <div className="my-2 button is-fullwidth is-7 title has-text-center">
                            Das portal wird derzeit ins Deutsche übersetzt!
                        </div>
                    )}
                    {languageMessage === 'sp' && (
                        <div className="my-2 button is-fullwidth is-7 title has-text-center">
                            ¡El portal se está traduciendo al alemán en este momento!
                        </div>
                    )}
                </div>
                <button className="modal-close is-large" aria-label="close" onClick={() => setIsActive(false)}></button>
            </div>
            <nav className="shyftbase_nav" role="navigation" aria-label="main navigation">
                <div className="shyftbase_main_nav">
                    <div className="shyftbase_main_nav_item logo guide-start">
                        <img
                            src="https://firebasestorage.googleapis.com/v0/b/public-contents.appspot.com/o/SHYFTBASE%2FShyftBase-Logo-A.png?alt=media&token=1d864aae-feaf-4564-a00d-b9af22807695"
                            alt="Shyftbase Logo"
                            width={35}
                        />
                    </div>
                    {getMainNavigations()}
                    <div className={``}></div>
                    <div className={`shyftbase_main_nav_item toggle`}></div>
                    <div className={`shyftbase_main_nav_item toggle}`} onClick={() => history.push('/help')}>
                        <Icon source={QuestionCircleIcon as IconSource} />
                        <p style={{ fontSize: 8 }}>{t('nav.drawer.help')}</p>
                    </div>
                    <div className={`shyftbase_main_nav_item toggle}`} onClick={() => setIsActive(true)}>
                        <Icon source={LanguageTranslateIcon as IconSource} />
                        <p style={{ fontSize: 8 }}>{t('nav.drawer.language')}</p>
                    </div>
                    <div className={`shyftbase_main_nav_item toggle}`} onClick={logout}>
                        <Icon source={PersonExitIcon as IconSource} />
                        <p>{t('nav.drawer.logout')}</p>
                    </div>
                </div>
            </nav>
        </>
    )
}
export default React.memo(Nav)
